<template lang="pug">
.panel-listing
    .card
        .card-header {{pageData.panelTitle}}
        .card-body
            .ad-item.row(v-for="item in pageData.listing")
                .col-4
                    .image
                        a(:href="item.url" target="_blank")
                            img(:src="item.showImage")
                .col-8
                    .details
                        a(:href="item.url" target="_blank")
                            h2
                                span.badge(:class="item.state == 1 ? 'badge-success' : 'badge-danger'") {{item.showStatus}}
                                | {{item.title}}
                        ul
                            li
                              i.icon-location-car.caricons
                              | {{item.showArea}}
                            li
                              i.icon-car-garage.caricons
                              | {{item.showCover}}
                            li
                              i.fa.fa-building
                              | {{item.address}}
                        .price {{item.showPrice}}
                        .btn-group
                            a.btn.btn-outline-success.btn-sm(:href="item.editUrl") {{LANG.userPanelActionEdit}}
                            a.btn.btn-outline-secondary.btn-sm(@click="askGo(item.soldUrl,LANG.askSetAsSold)" v-if="item.status == 1 ") {{LANG.userPanelActionSold}}
                            a.btn.btn-outline-secondary.btn-sm(@click="changeStatus(item.changeStatus)" v-if="item.status == 2 ") {{LANG.userPanelActionSelling}}
            nav.pager.pagination.mt-2(v-html="pageData.pager")
</template>
<script>
    import $ from "jquery";
    import util from "../lib/util";
    export default {
        name: 'PanelListing',
        data() {
            return {
                LANG : window.LANG,
                pageData : window.pageData,
            }
        },
        beforeMount: function () {

        },
        methods : {

            render : function(){
                var mThis = this;
                $.getJSON(this.pageData.baseUrl , function(rep){
                    util.loading('hide');
                    if (rep.errorCode != 0){
                        return;
                    }
                    mThis.pageData = rep.msg;
                });

            },

            changeStatus : function(url){
                var mThis = this;
                util.loading();
                $.getJSON(url.replace(/%status%/g,'0'),function(rep){
                    if (rep.errorCode != 0){
                        util.alert(rep.msg);return;
                    }
                    mThis.render();
                });
            },

            askGo : function(url,msg){
                if (!confirm(msg)){
                    return;
                }
                var mThis = this;
                util.loading();
                $.getJSON(url,function(rep){
                    if (rep.errorCode != 0){
                        util.alert(rep.msg);return;
                    }
                    mThis.render();
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/ParkingListing.vue